// Mục đích xuất
export default {
  OutwardUsed: 0, // 'Xuất dùng',
  OutwardSale: 1, // 'Xuất bán',
  OutwardOther: 2, // 'Xuất khác',
};
